import {BrokerList} from "./BrokerList";
import {BrokerEdit} from "./BrokerEdit";
import {BrokerCreate} from "./BrokerCreate";

export default {
    list: BrokerList,
    create: BrokerCreate,
    edit: BrokerEdit
};
